import React from "react"
import { Link as PrismicLink } from "prismic-reactjs"

import Button from "legacy/components/shared/Button"
import { Text } from "legacy/components/shared/base"
import Link from "legacy/components/shared/Link"
import { PrismicLinkType } from "types/__generated__/gatsby-graphql"

interface OwnProps {
  lastItem: boolean
  text: string
  url: PrismicLinkType
}

type HeroButtonProps = OwnProps

const HeroButton: React.FC<HeroButtonProps> = ({
  lastItem,
  text,
  url,
}): React.ReactElement => {
  const linkType = url.link_type

  return (
    <>
      {linkType === "Document" ? (
        <Link
          display={["block", "inline-block"]}
          mb={lastItem ? "0" : "15"}
          mr={lastItem ? "0" : "10"}
          to={PrismicLink.url(url)}
          width={["100%", "auto"]}
        >
          <Button
            fontSize={["17", "text.body"]}
            variant="square"
            width={["100%", "auto"]}
          >
            {text}
          </Button>
        </Link>
      ) : (
        <Text
          as="a"
          display={["block", "inline-block"]}
          href={PrismicLink.url(url)}
          mb={lastItem ? "0" : "15"}
          mr={lastItem ? "0" : "10"}
          width={["100%", "auto"]}
        >
          <Button
            fontSize={["16", "text.button"]}
            variant="square"
            width={["100%", "auto"]}
          >
            {text}
          </Button>
        </Text>
      )}
    </>
  )
}

export default HeroButton
